// SPDX-License-Identifier: MIT
// Honest readiness heuristic for the collapsed plan card's gauge. PURE, no AI —
// it weights the real signal that exists once an idea is magnified. NOT a fake
// progress bar: every contribution maps to something the user actually provided.
export interface ReadinessInput {
  answersCount: number;   // discovery answers captured
  outlineCount: number;   // fiche outline bullets
  hasStack: boolean;      // a stack was decided
  hasFirstSteps: boolean; // first-steps present
}

export type ReadinessState = 'building' | 'almost' | 'ready';
export interface Readiness { pct: number; ready: boolean; state: ReadinessState; }

export function readiness(input: ReadinessInput): Readiness {
  const answers = Math.min(input.answersCount, 3) / 3;      // up to 3 answers → 1
  const outline = Math.min(input.outlineCount, 5) / 5;      // up to 5 bullets → 1
  const stack = input.hasStack ? 1 : 0;
  const steps = input.hasFirstSteps ? 1 : 0;
  // Weights: answers 0.35, outline 0.35, stack 0.15, steps 0.15 → sums to 1.
  const score = answers * 0.35 + outline * 0.35 + stack * 0.15 + steps * 0.15;
  const pct = Math.max(0, Math.min(100, Math.round(score * 100)));
  const state: ReadinessState = pct >= 80 ? 'ready' : pct >= 50 ? 'almost' : 'building';
  return { pct, ready: pct >= 80, state };
}
